<template>
  <div>
      <v-container>
          <CRUDCriteria
              :showReset="false"
              :showSearch="false"
          >
          <template v-slot:criteriaRows>
          <v-row>
            <v-col cols="3">
              <FySelect
                v-model="fiscalYear"
                :fyRange="fiscalYearRange"
                id="check-OD-Balcriteria-FY-select"
                class="checkODBalCriteriaFYSelect"
                @input="onChangeFy"
              />
            </v-col>
            <v-col cols="3">
              <ClarionDateControl
                v-model="fromDate"
                :isRequired="false"
                :isIsoDate="true"
                :isToggle="false"
                :label="`From Date`"
              />
            </v-col>
            <v-col cols="3">
              <ClarionDateControl
                v-model="toDate"
                :isRequired="false"
                :isIsoDate="true"
                :isToggle="false"
                :label="`To Date`"
              />
            </v-col>
            <v-col cols="3">
              <v-btn color="primary"
              rounded
              @click="gatherInfo"
              >
              Gather Information
              </v-btn>
            </v-col>
          </v-row>
        </template>
          </CRUDCriteria>
          <h2 align="center">MISC COLLECTIONS COMPARED TO GL BALANCE</h2>
    <div align="center">
      <span class="ml-4">
          {{ `From:${fromDate}` }}
      </span>
      <span class="ml-4">
          {{ `To:${toDate}` }}
      </span>
    </div>
    <hr>
    <v-simple-table
      id="glUtilInterestApportionmentReportTable"
      class="gl-util-interest-apportionment-report-table"
      dense
    >
      <template v-slot:default>
        <thead  >
          <tr>
            <th>
              Date
            </th>
            <th class="text-right">
              MiscReceipt Collections
            </th>
            <th class="text-right">
              Special Apportionments
            </th>
            <th class="text-right">
              Running Total
            </th>
            <th class="text-right">
              GL Balance
            </th>
            <th class="text-right"></th>
          </tr>
        </thead>
        <tbody>
          <template >
          <tr
          v-for="item in loadData"
          :key="item.date"
          :class="getRowClass(item)"
          >
            <td class="text-left">{{ item.date }}</td>
            <td class="text-right">{{ amountFormat(item.miscAmt)}}</td>
            <td class="text-right">{{ amountFormat(item.miscSAAmt)}}</td>
            <td class="text-right">{{ amountFormat(item.runningAmt)}}</td>
            <td class="text-right">{{ amountFormat(item.glBalanceAmt)}}</td>
          </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  <hr>
      </v-container>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import FySelect from '../../common/FySelect.vue';
import CRUDCriteria from '../../common/base/crud/CRUDCriteria.vue';
import { calculateFiscalYears } from '../../../util/shared/tmc-global';
import { amountFormat } from '../../../util/shared/vue-global';

export default {
  name: 'CheckMISCBalToGL',
  components: {
    CRUDCriteria,
    ClarionDateControl,
    FySelect,
  },
  data: () => ({
    fiscalYear: undefined,
    glBaseCrudKey: 'glDailyTransaction',
    fromDate: '',
    toDate: '',
    loadData: [],
  }),
  created() {
    this.initialValue();
  },
  computed: {
    ...mapGetters(['todaysDate']),
    // ...mapGetters('base/crud', ['criteria', 'item', 'items']),
    ...mapState({
      fiscalYearRange: (state) => {
        const registerdYears = state.glDaily.glDailyTransaction.regYears || {};
        return calculateFiscalYears(registerdYears);
      },
    }),
  },
  methods: {
    ...mapActions('glDaily/glDailyTransaction', ['loadFiscalRegYears']),
    ...mapActions('glDaily/checkMISCBalanceToGL', ['miscBalToGLGatherInformation']),
    amountFormat,
    async initialValue() {
      await this.loadFiscalRegYears({ baseCrudKey: this.glBaseCrudKey });
      const regYears = (this.fiscalYearRange || []);
      this.fiscalYear = (regYears[regYears.length - 1] || {}).year;
      this.fromDate = this.todaysDate;
      this.toDate = this.todaysDate;
    },
    onChangeFy(val) {
      this.fiscalYear = val;
    },
    getRowClass(item) {
      return item.matchAmtFlag ? 'accent-1' : 'red accent-1';
    },
    async gatherInfo() {
      const criteria = {
        fiscalYear: this.fiscalYear,
        fromDate: this.fromDate,
        toDate: this.toDate,
      };
      const result = await this.miscBalToGLGatherInformation({ criteria });
      this.loadData = result;
    },
  },
};
</script>
